import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 10v10","key":"svg-0"}],["path",{"d":"M12 10l4 4","key":"svg-1"}],["path",{"d":"M12 10l-4 4","key":"svg-2"}],["path",{"d":"M4 4h3m13 0h-3m-3.5 0h-3","key":"svg-3"}]]

const IconArrowBarToUpDashed = createReactComponent('outline', 'arrow-bar-to-up-dashed', 'ArrowBarToUpDashed', __iconNode);

export default IconArrowBarToUpDashed;